import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Import global styles
import App from './App'; // Import the main App component
import * as serviceWorker from './serviceWorker'; // Import service worker utility

// Render the App component into the root element
ReactDOM.createRoot(document.getElementById('root')).render(<App />);

// Unregister the service worker (prevents offline caching)
serviceWorker.unregister();